'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const CheckboxError = createSvgIcon(
  <g fillRule="evenodd">
    <rect fill="#FFF" width="16" height="16" x="4" y="4" rx="2" />
    <path
      fillRule="nonzero"
      d="M18,4 C19.1045695,4 20,4.8954305 20,6 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,6 C4,4.8954305 4.8954305,4 6,4 L18,4 Z M18,6 L6,6 L6,18 L18,18 L18,6 Z"
    />
  </g>,
  'CheckboxError'
);

export default CheckboxError;
